<template>
    <div class="page page-pai_hang_bang pr">
        <img v-if="showBack" @click="goHome" src="@/assets/image/back.png"  class="back" alt="">
        <div v-if="!showResult">
            <div v-for="(item,index) in list"
                :key="index"
                :id='item.questionId'
                :kk='index'
                :class="'item pr t ' + (current == index? ' move ' :'')+ (current > index? ' pass ' :'')"
            >
                <div class="timer">
                    <div class="timer-inner">
                        {{time}}S
                    </div>
                </div>
                <div class="desc">
                    {{item.questionTitle}}
                </div>
                <div class="btns">
                    <div :class="'btn ' + (current == index && selectIndex && item.rightOption == 'A' ?'r ': '')+ (current == index && selectIndex?' disabled ': '') + (current == index && selectIndex && !selectIsRight && selectIndex == 'A' ?'w ': '')" @click="onSelect('A', item, index)">{{item.optionA}}</div>
                    <div :class="'btn ' + (current == index && selectIndex && item.rightOption == 'B' ?'r': '') + (current == index && selectIndex?' disabled ': '')+ (current == index && selectIndex && !selectIsRight && selectIndex == 'B' ?'w ': '')" @click="onSelect('B', item, index)">{{item.optionB}}</div>
                    <div :class="'btn ' + (current == index && selectIndex && item.rightOption == 'C' ?'r': '') + (current == index && selectIndex?' disabled ': '')+ (current == index && selectIndex && !selectIsRight && selectIndex == 'C' ?'w ': '')" @click="onSelect('C', item, index)">{{item.optionC}}</div>
                    <div v-if="timeOver">正确答案是 {{item.rightOption}} ：{{item['option' + item.rightOption]}}</div>
                </div>
                <div class="tipsss pa">
                    <img src="@/assets/image/tip.png" alt="">
                </div>
            </div>
            

        </div>
        <div class="top" v-else>
            <!-- <div v-if="!dialogDatiTips && !dialogDatiTipss && !dialogDatiTipsss">
                <img v-if='grade == 1' src="@/assets/image/dati_1.png" alt="">
                <img v-if='grade == 2' src="@/assets/image/dati_2.png" alt="">
                <img v-if='grade == 3' src="@/assets/image/dati_3.png" alt="">
                <img v-if='grade == 4' src="@/assets/image/dati_4.png" alt="">
            </div> -->
            <div class="desc desc-res" v-if="!dialogDatiTips && !dialogDatiTipss && !dialogDatiTipsss">
                <p>本次答对 {{right}} 道题<br/>获得 <strong class="c-red">{{right * 10}}</strong> 分</p>
                <!-- <p>获得称号 <em>{{chenghaoText}}</em></p> -->
            </div>
            <div class="desc" v-if="dialogDatiTips">
                本次答题之前，答题次数已用光，本次答题不计入结果。
            </div>
            <div class="desc" v-if="dialogDatiTipss">
                您的答题频率太高，请稍后重试！
            </div>
            <div class="desc" v-if="dialogDatiTipsss">
                答题次数已用光，快去做任务吧！
            </div>
            <div class="btns">
                <div class="button" @click="onShare">分享好友</div>
                <div class="button" @click="reload">继续挑战</div>
                <div class="button" @click="onGo('/chou_jiang')">去抽奖</div>
                <div class="button" @click="onGo('/')">回到首页</div>
            </div>
        </div>
        <share ref='share'></share>
        <!-- 提交答题结果无效 -->
        <el-dialog
            :visible.sync="dialogDatiTipNo1"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">答题次数已用光，快去做任务吧！</div>
            <br />
            <div class="button" @click="dialogDatiTipNo1 = false">知道啦</div>
        </el-dialog>
        <!-- 提交答题结果无效 -->
        <el-dialog
            :visible.sync="dialogDatiTipNo"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">本次答题之前，答题次数已用光，本次答题不计入结果。</div>
            <br />
            <div class="button" @click="dialogDatiTipNo = false">知道啦</div>
        </el-dialog>
        <!-- 中途无效 -->
        <el-dialog
            :visible.sync="dialogDatiTipLogout"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">
                答题中途退出<br/>
                会减少一次答题次数哦~
            </div>
            <br />
            <el-row>
                <el-col span="10" offset="1">
                    <div class="button button-logot" @click="$router.push('/')">确认退出</div>
                </el-col>
                <el-col span="10" offset="2">
                    <div class="button" @click="dialogDatiTipLogout = false">继续答题</div>
                </el-col>
            </el-row>
            
            
        </el-dialog>
        <!-- 提交答题频率太高 -->
        <el-dialog
            :visible.sync="dialogDatiTipGao"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">您的答题频率太高，请稍后重试！</div>
            <br />
            <div class="button" @click="dialogDatiTipGao = false">知道啦</div>
        </el-dialog>
    </div>
</template>

<script>
    // import axios from 'axios'
import api from '@/assets/js/api'
import { cookie} from '@/assets/js/utils'
import share  from '../share.vue'
    export default {
        name: "notice",
        data() {
            return {
                showBack: true,
                actId: 1,
                sss: false,
                answerId: '',
                dialogDatiTipLogout: false,
                dialogDatiTipNo1: false,
                dialogDatiTipNo: false,
                dialogDatiTipGao: false,
                dialogDatiTips: false,
                dialogDatiTipss: false,
                dialogDatiTipsss: false,
                isAllowSelect: true, // 倒计时结束，展示正确答案时，不允许选择选项
                showResult: false, // 展示答题结果
                time: 30,
                isComputed: false, // 防止重复提交
                timeConst: 30,
                timer: '',
                list: [],
                timeOver: false,
                selectIsRight: true,
                totalScore: 0, // 答题总得分
                rightArr: [], // 答对题目索引
                arr: {}, // 所有题的答题状况
                current: 0, // 当前答题卡索引
                selectIndex: '', // 选择的答案项，已选择过的，以此设置为不可点击状态


                right: 0,
                score: 0,
                grade: 1,
                chenghaoText: ''
            }
        },
        components:{
            share
        },
        methods: {
            goHome(){
                if(this.showResult){
                    this.$router.push('/');
                }{  
                    this.dialogDatiTipLogout = true;
                }
                
            },
            reload(){
                location && location.reload();
            },
            async init(){
                let self = this;
                this.initItem();
                let data = await this.onGetList()
                if(!data){
                    self.showResult = true;
                    self.dialogDatiTipLogout = false;
                    self.dialogDatiTipsss = true;
                    return;
                }
                this.current = 0;
                this.arr = {};
                this.totalScore = 0;
                this.timeGo();
            },
            async onGetList(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.$message({
                        message: '请先登录'
                    })
                    self.$router.push('/')
                }
                let res = await api({
                    method: 'questionList',
                    token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                let status = false;
                if(code ==200){
                    self.list = data.questionList;
                    self.answerId = data.answerId;
                    status = true;
                }else if(code == 196){
                    self.dialogDatiTipNo1 = true;
                    status = false;
                }else{
                    self.$message({
                        message: msg || '数据错误，请重试！'
                    })
                    status = false;
                }  
                return new Promise((resolve, reject)=>{
                    resolve(status)
                })
            },
            onGo(path){
                this.$router.push(path)
            },
           
            onSelect(mySelect, item, index){
                let self = this;
                if(self.timeOver){
                    return;
                }
                if(this.selectIndex){
                    return;
                }

                if(!self.isAllowSelect){
                    return;
                }
                
                this.selectIndex = mySelect; // 我选择的
                this.selectIsRight = this.list[this.current].rightOption == mySelect;
                if(this.selectIsRight){
                    self.rightArr.push(self.current);
                }
                
                self.arr["questionId." + (index + 1)]= item.questionId;
                self.arr["answer." + (index + 1)]= mySelect;
                // console.log(self.arr)
                let tt = setTimeout(function(){
                    clearTimeout(tt);
                    self.nextStep(2)
                    
                }, 1000)
            },

            nextStep(i){
                let self = this;
                if(self.list.length == self.current + 1){
                    self.onComputed(2);
                }else{
                    self.onNextItem();
                }
                self.timeOver = false;
            },

            /** 
             * 初始化答题状态
            */
            initItem(){
                this.selectIsRight = true;
                this.selectIndex = '';
            },
            /** 
             * 下一题
            */
            onNextItem(){
                this.initItem();
                this.timeGo();
                this.current++;
                this.isAllowSelect = true;
                
            },
            /** 
             * 计算答题结果
            */
            onComputed(i){
                let self = this;
                self.totalScore = 0;
                if(!self.isComputed) {
                    self.isComputed = true
                    clearInterval(self.timer);
                }

                self.right = self.rightArr.length;
                
                self.getResult();
                // console.log('总得分', self.rightArr)
            },
            // 时间到，展示正确答案，进入下一题或者结算
            timeGo(){
                let self = this;
                if(self.timer){
                    clearInterval(self.timer);
                }
                if(self.list.length == self.current + 1){//已结束
                    if(self.isComputed){
                        self.isComputed = false;
                    }else{
                        // self.onComputed(1);
                    }
                    return;
                    
                }
                self.resetTimer();
                self.timer = setInterval(() => {
                    if(self.time == 0){
                        clearInterval(self.timer);
                        self.timeOver = true;
                        self.isAllowSelect = false;
                        // 该题目未选择，时间到
                        let item = self.list[self.current];
                        self.arr["questionId." + (self.current + 1)]= item.questionId;
                        self.arr["answer." + (self.current + 1)]= '';
                        let ttt = setTimeout(function(){
                            clearTimeout(ttt);
                            
                            self.nextStep(1);
                        }, 1500)
                        
                        return;
                    }
                    self.time--;
                }, 1000);
            },
            resetTimer(){
                this.time = this.timeConst;
            },
         
            onShare(){
                this.$refs['share'].share({
                    // title: '分享抽奖结果'
                })
            },
            // 提交答题数据，返回结果
            async getResult(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                if(self.sss){
                    return;
                }
                self.sss = true;

                let res = await api({
                    method: 'answer',
                    token,
                    answerId: self.answerId,
                    rightCount: self.right,
                    ...self.arr
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200){
                    self.chenghaoText = data.levelName;
                    self.showResult = true;
                    self.dialogDatiTipLogout = false;
                    self.grade = data.level;
                }else if(code == 196){
                    self.dialogDatiTipNo = true;
                    self.dialogDatiTips = true;
                    self.showResult = true;
                    self.dialogDatiTipLogout = false;
                }else if(code == 170){
                    self.dialogDatiTipGao = true;
                    self.dialogDatiTipss = true;
                    self.showResult = true;
                    self.dialogDatiTipLogout = false;

                }else{
                    self.$message({
                        message: msg || '提交失败'
                    })
                }
            }
        },
        mounted() {
            let self =this;
            self.actId = self.query && self.query.__sa || 1;
            this.init();
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../../assets/css/var.less';
.t {
    transition: all 0.5s ease-in-out;
}
.page-pai_hang_bang {
    padding-top: 80px;
    width: 100%;
    overflow: hidden;
    height: 1000px;
    max-height: 2000;
}
.btns {
    .btn {
        position: relative;
        margin-bottom: 10px;
        width: 80%;
        line-height: 24px;
        border: 1px solid #edb635;
        margin: 15px auto;
        background-color: #fff;
        border-radius: 10px;
        color: @c-y;
        font-size: 14px;
        text-align: left;
        box-shadow: 1px solid #000;
        padding: 10px 20px;
        &.disabled {
            opacity: 0.9;
        }
        &.r {
            background: rgba(152,172,113,0.3);
            border-color: #98ac71;
            &::after {
                position: absolute;
                content: '.';
                right: 7px;
                top: 13px;
                width: 15px;
                height: 15px;
                background: url(../../assets/image/dati_r.png);
                background-size: 100% 100%;
            }
        }
        &.w {
            background: rgba(238,146,118,0.3);
            border-color: #ee9276;
            &::after {
                content: '.';
                position: absolute;
                right: 7px;
                top: 13px;
                width: 15px;
                height: 15px;
                background: url(../../assets/image/dati_w.png);
                background-size: 100% 100%;
            }
        }
    }
}

.tipsss {
    position: absolute;
    height: 60px;
    width: 100%;
    margin:0 auto;
    bottom: -80px;
    left: 0;
    right: 0;
    img {
        margin: 0 auto;
        width: 60%;
    }
}
.item {
    transform: translateX(1500px);
    position: absolute;
    top: 80px;
    left: unit(30 / @page-width * 100, vw);
    text-align: center;
    padding-top: 80px;
    padding-bottom: 20px;
    line-height: 36px;
    font-size: 18px;
    
    width: unit(690 / @page-width * 100, vw);
    background-color: @c-bg;
    border-radius: 10px;
    margin-bottom: 20px;
    .timer {
        position: absolute;
        top: -40px;
        left: 50%;
        margin-left: -40px;
        border-radius: 100px;
        width: 60px;
        height: 60px;
        padding: 10px;
        box-sizing: content-box;
        background: #e9af33;
        .timer-inner {
            background-color: #f2eeb1;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border-radius: 60px;
            color: @c-red1;
            font-weight: bold;
            font-size: 20px;
            box-shadow: 0 0 2px #e9af33;
        }
    }
    .desc {
        width: 80%;
        margin: 0 auto;
        color: @c-y;
        text-align: left;
        line-height: 30px;
    }
    em {
        color: @c-red1;
        font-weight: bold;
        font-style: normal;
    }
}
.move {
    transform: translateX(0)
}
.pass {
    transform: translateX(-1500px)
}

.desc-res {
    padding: 50px 0 20px;
}



.page-pai_hang_bang {
    padding-top: 40px;
}
.c-red {
    color: @c-red;
    font-size: 22px;
}
.button {
    margin-top: 15px;
}
.top {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    line-height: 36px;
    font-size: 18px;
    margin: 0 auto;
    width: unit(690 / @page-width * 100, vw);
    background-color: @c-bg;
    padding: unit(35 / @page-width * 100, vw);
    border-radius: 10px;
    margin-bottom: 20px;
    img {
        padding-bottom: 20px;
        max-width: 50%;
        height:unit(400 / @page-width * 100, vw);
    }
    em {
        color: @c-red1;
        font-weight: bold;
        font-style: normal;
    }
}
.tip-text {
    text-align: center;
    font-size: 18px;
    color: @c-y;
}
.button {
    border: 1px solid @c-red;
}
.button-logot {
    background-color: @c-bg;
    color: @c-red;
    border: 1px solid @c-red;
}
</style>